export default function PageJsonLd() {
  const serviceSchema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Тренинг по выявлению потребностей клиента',
    provider: {
      '@type': 'Person',
      name: 'Алексей Сивко',
      description: 'Бизнес-тренер с более чем 18-летним опытом в продажах и переговорах',
      url: 'https://sivko.by/',
    },
    description: 'Корпоративный тренинг по выявлению потребностей клиента. Научите менеджеров задавать правильные вопросы, понимать реальные мотивы клиента и увеличивать конверсию продаж. Минск, Беларусь, онлайн.',
    areaServed: ['Беларусь', 'Россия', 'Казахстан', 'Израиль'],
    serviceType: 'Корпоративное обучение выявлению потребностей',
    offers: {
      '@type': 'Offer',
      availability: 'https://schema.org/InStock',
      category: 'Корпоративный тренинг',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: 'Что такое выявление потребностей?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Выявление потребностей — это ключевой этап продажи, на котором менеджер с помощью правильных вопросов и активного слушания определяет истинные задачи, проблемы и мотивы клиента. Без качественной диагностики невозможно предложить релевантное решение, и сделка либо срывается, либо закрывается с большими скидками.',
        },
      },
      {
        '@type': 'Question',
        name: 'Почему сотрудники плохо задают вопросы?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Большинство менеджеров не обучены технике вопросов. Они либо сразу переходят к презентации продукта, либо задают поверхностные вопросы вроде «Что вас интересует?». Причина — отсутствие структурированной методологии (SPIN, открытые и извлекающие вопросы) и страх показаться навязчивым. Тренинг устраняет эти барьеры через практику на реальных переговорах.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли использовать SPIN?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, методика SPIN (Ситуационные, Проблемные, Извлекающие, Направляющие вопросы) — один из центральных инструментов тренинга. Мы адаптируем SPIN под специфику вашего бизнеса: B2B или B2C, длинный или короткий цикл сделки, продукт или услугу. Участники отрабатывают каждый тип вопросов на реальных кейсах компании.',
        },
      },
      {
        '@type': 'Question',
        name: 'Подходит ли тренинг для B2B?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, более 70% наших проектов — это B2B-компании. Мы обучаем выявлять потребности на разных уровнях: у ЛПР, влиятельных лиц, пользователей. Работаем с многоэтапными закупками, сложными продуктами и длинным циклом сделки. Учим определять не только явные, но и скрытые потребности бизнес-клиентов.',
        },
      },
      {
        '@type': 'Question',
        name: 'Подходит ли для B2C?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, программа адаптируется под B2C-сегмент. В розничных продажах выявление потребностей критически важно, потому что клиент часто сам не осознаёт, что ему нужно. Мы учим менеджеров через правильные вопросы помогать клиенту сформулировать его истинный запрос, что повышает и конверсию, и средний чек.',
        },
      },
      {
        '@type': 'Question',
        name: 'Сколько длится обучение?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Форматы варьируются: интенсивный тренинг — 1-2 полных дня, модульная программа — от 2 недель до 2 месяцев, комплексная программа с сопровождением — 3-6 месяцев. Точная продолжительность определяется после диагностики текущего уровня команды и поставленных целей.',
        },
      },
      {
        '@type': 'Question',
        name: 'Можно ли проводить онлайн?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, тренинг полностью доступен в онлайн-формате: живые сессии с отработкой диалогов через видеосвязь, ролевые переговоры, детальный разбор реальных записей общения с клиентами. Онлайн-формат полностью сохраняет практическую направленность программы.',
        },
      },
      {
        '@type': 'Question',
        name: 'Есть ли сопровождение после тренинга?',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'Да, посттренинговое сопровождение — обязательная часть программы. Мы разбираем новые записи переговоров, поддерживаем участников в Telegram, помогаем внедрять стандарты общения. Именно сопровождение обеспечивает закрепление навыков и устойчивый рост конверсии.',
        },
      },
    ],
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Главная',
        item: { '@id': 'https://business-training.by/', name: 'Главная' },
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: 'Продажи и переговоры',
        item: { '@id': 'https://business-training.by/prodazhi-i-peregovory/trening-po-prodazham', name: 'Продажи и переговоры' },
      },
      {
        '@type': 'ListItem',
        position: 3,
        name: 'Тренинг по выявлению потребностей клиента',
        item: { '@id': 'https://business-training.by/prodazhi-i-peregovory/trening-po-vyyavleniyu-potrebnostey', name: 'Тренинг по выявлению потребностей клиента' },
      },
    ],
  };

  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(serviceSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
    </>
  );
}